import { useState, useEffect } from "react";
import { getVcFeed } from "../lib/api.js";

export function useVcFeed(sort: string) {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    getVcFeed(sort)
      .then(setData)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [sort]);

  return { data, loading, error, refetch: () => getVcFeed(sort).then(setData) };
}
